import '../../assets/index20.css';var Z = Object.defineProperty, H = Object.defineProperties;
var K = Object.getOwnPropertyDescriptors;
var p = Object.getOwnPropertySymbols;
var W = Object.prototype.hasOwnProperty, z = Object.prototype.propertyIsEnumerable;
var B = (r, a, n) => a in r ? Z(r, a, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[a] = n, g = (r, a) => {
  for (var n in a || (a = {}))
    W.call(a, n) && B(r, n, a[n]);
  if (p)
    for (var n of p(a))
      z.call(a, n) && B(r, n, a[n]);
  return r;
}, T = (r, a) => H(r, K(a));
var G = (r, a) => {
  var n = {};
  for (var t in r)
    W.call(r, t) && a.indexOf(t) < 0 && (n[t] = r[t]);
  if (r != null && p)
    for (var t of p(r))
      a.indexOf(t) < 0 && z.call(r, t) && (n[t] = r[t]);
  return n;
};
import { jsxs as d, jsx as e, Fragment as M } from "react/jsx-runtime";
import { Button as c } from "../Button/index.js";
import { Title as Q } from "../Title/index.js";
import { PaperPlaneTopFarFAIcon as L, TriangleExclamationFarFAIcon as U, TrashFarFAIcon as A, XMarkFarFAIcon as V } from "../Icons/index.js";
import { forwardRef as ee, useEffect as re } from "react";
import { T as X } from "../../Transition-wSuCFYNq.js";
import { S as b } from "../../Stack-Bh9dsrlC.js";
const ae = "Modal-module__wrapper___rdgyn", ne = "Modal-module__overlay___9MGnZ", te = "Modal-module__modal___ET0NO", le = "Modal-module__header___icaSI", oe = "Modal-module__title___NGy-S", de = "Modal-module__closeButton___lXGNX", ie = "Modal-module__contentWrapper___yTMd3", ce = "Modal-module__footer___yQ3IF", se = "Modal-module__variantContainer___MC0Id", _e = "Modal-module__variantTitle___Oh8TJ", me = "Modal-module__variantMessage___6-Dwd", ve = "Modal-module__variantActions___0s9QG", he = "Modal-module__variantIcon___Qqtla", o = {
  wrapper: ae,
  overlay: ne,
  modal: te,
  header: le,
  title: oe,
  closeButton: de,
  contentWrapper: ie,
  footer: ce,
  variantContainer: se,
  variantTitle: _e,
  variantMessage: me,
  variantActions: ve,
  variantIcon: he
}, ue = ee((pe, R) => {
  var E = pe, {
    centered: r = !0,
    children: a,
    className: n,
    classNames: t = {},
    onClose: m,
    opened: _,
    position: j = "center",
    size: O = "360px",
    title: v,
    actions: k = [],
    variant: s = "default",
    message: F,
    primaryActionLabel: C,
    secondaryActionLabel: $,
    onPrimaryAction: w,
    onSecondaryAction: y,
    transition: S = "slide-up",
    transitionDuration: I = 200,
    transitionTimingFunction: x = "ease",
    confirmationIcon: q = /* @__PURE__ */ e(L, { size: 16 }),
    warningIcon: D = /* @__PURE__ */ e(U, { size: 16 }),
    dangerIcon: J = /* @__PURE__ */ e(A, { size: 16 }),
    primaryActionVariant: h = "accent",
    secondaryActionVariant: N = "tertiary",
    withinPortal: fe = !0
  } = E, P = G(E, [
    "centered",
    "children",
    "className",
    "classNames",
    "onClose",
    "opened",
    "position",
    "size",
    "title",
    "actions",
    "variant",
    "message",
    "primaryActionLabel",
    "secondaryActionLabel",
    "onPrimaryAction",
    "onSecondaryAction",
    "transition",
    "transitionDuration",
    "transitionTimingFunction",
    "confirmationIcon",
    "warningIcon",
    "dangerIcon",
    "primaryActionVariant",
    "secondaryActionVariant",
    "withinPortal"
  ]);
  re(() => {
    const i = (u) => {
      u.key === "Escape" && _ && m();
    };
    return _ && (document.body.style.overflow = "hidden", document.addEventListener("keydown", i)), () => {
      document.body.style.overflow = "unset", document.removeEventListener("keydown", i);
    };
  }, [_, m]);
  const Y = () => {
    if (s === "default") {
      const i = k.filter((l) => l.position === "left"), u = k.filter((l) => l.position !== "left");
      return /* @__PURE__ */ d(M, { children: [
        v && /* @__PURE__ */ d("div", { className: `${o.header} ${t.header || ""}`, children: [
          /* @__PURE__ */ e(Q, { order: 4, className: o.title, children: v }),
          /* @__PURE__ */ e(
            c,
            {
              className: o.closeButton,
              onClick: m,
              variant: "tertiary",
              size: "lg",
              children: /* @__PURE__ */ e(V, {})
            }
          )
        ] }),
        /* @__PURE__ */ e("div", { className: `${o.contentWrapper} ${t.body || ""}`, children: a }),
        k.length > 0 && /* @__PURE__ */ d("div", { className: `${o.footer} ${t.footer || ""}`, children: [
          i.map((l, f) => /* @__PURE__ */ e(
            c,
            {
              variant: l.variant || "tertiary",
              onClick: l.onClick,
              danger: l.danger,
              style: { marginLeft: "-0.5rem" },
              children: l.label
            },
            `left-${f}`
          )),
          /* @__PURE__ */ e("div", { style: { flex: 1 } }),
          u.map((l, f) => /* @__PURE__ */ e(
            c,
            {
              variant: l.variant || (f === u.length - 1 ? "accent" : "secondary"),
              onClick: l.onClick,
              danger: l.danger,
              children: l.label
            },
            `right-${f}`
          ))
        ] })
      ] });
    }
    return /* @__PURE__ */ d("div", { className: `${o.variantContainer} ${t.body || ""}`, children: [
      /* @__PURE__ */ d(b, { className: o.variantIcon, "data-variant": s, children: [
        s === "confirmation" && q,
        s === "warning" && D,
        s === "danger" && J
      ] }),
      /* @__PURE__ */ d(b, { gap: "xxs", children: [
        v && /* @__PURE__ */ e(Q, { order: 4, className: o.variantTitle, children: v }),
        F && /* @__PURE__ */ e("p", { className: o.variantMessage, children: F })
      ] }),
      /* @__PURE__ */ d("div", { className: o.variantActions, children: [
        s === "confirmation" && /* @__PURE__ */ d(M, { children: [
          /* @__PURE__ */ e(c, { variant: N, onClick: y, children: $ || "Edit" }),
          /* @__PURE__ */ e(c, { variant: h, onClick: w, children: C })
        ] }),
        s === "warning" && /* @__PURE__ */ d(M, { children: [
          /* @__PURE__ */ e(c, { variant: N, onClick: y, children: $ || "Cancel" }),
          /* @__PURE__ */ e(c, { variant: h, onClick: w, children: C || "Leave" })
        ] }),
        s === "danger" && /* @__PURE__ */ d(M, { children: [
          /* @__PURE__ */ e(c, { variant: N, onClick: y, children: $ || "Cancel" }),
          /* @__PURE__ */ e(c, { danger: h === "primary", variant: h, onClick: w, children: C || "Delete" })
        ] })
      ] })
    ] });
  };
  return /* @__PURE__ */ d("div", { className: `${o.wrapper} ${t.wrapper || ""}`, children: [
    /* @__PURE__ */ e(
      X,
      {
        mounted: _,
        transition: "fade",
        duration: I,
        timingFunction: x,
        children: (i) => /* @__PURE__ */ e("div", { className: `${o.overlay} ${t.overlay || ""}`, onClick: m, style: i })
      }
    ),
    /* @__PURE__ */ e(
      X,
      {
        mounted: _,
        transition: S,
        duration: I,
        timingFunction: x,
        children: (i) => /* @__PURE__ */ e(
          "div",
          T(g({
            className: `${o.modal} ${n || ""}`,
            style: g(T(g({}, i), {
              maxWidth: O
            }), j === "center" && r ? {
              top: "50%",
              transform: `${i.transform || ""} translateY(-50%)`
            } : {}),
            ref: R
          }, P), {
            children: Y()
          })
        )
      }
    )
  ] });
});
ue.displayName = "Modal";
export {
  ue as Modal
};
